import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-documents-profile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './documents-profile.html',
  styleUrl: '../../../../employee-details.component.scss',
})
export class DocumentsProfileComponent {
  @Input() employeeData: any;
}
